import { zodResolver } from '@hookform/resolvers/zod';
import CT from '@marketplace-ai/tags';
import { FormProvider } from 'react-hook-form';
import {
  Button,
  FormActions,
  FormLayout,
  MaskedInput,
  FormRow as Row,
  FormSection as Section,
  Select,
} from '~/components';
import { TextInput } from '../../../components';
import { useCustomForm } from '../../../hooks/useCustomForm';
import { emptyRequestForm, PEER_RELATIONSHIP_OPTIONS } from './constants';
import { peerReqSchema, PeerRequestFormValues } from './types';

const TAGS = CT.peerRefReq.form;

interface FormProps {
  handleClose: () => void;
  submitSuccess: (values: PeerRequestFormValues) => void;
  submitError: (err: unknown) => void;
}

export const PeerReqForm = (props: FormProps) => {
  const { handleClose, submitError, submitSuccess } = props;
  const methods = useCustomForm<PeerRequestFormValues>({
    resolver: zodResolver(peerReqSchema),
    defaultValues: emptyRequestForm,
  });
  const { handleSubmit } = methods;

  return (
    <>
      <div>
        <p className="pb-5">Please fill out the information to get send a request.</p>
      </div>
      <FormProvider {...methods}>
        <form
          data-cy={TAGS.form}
          onSubmit={handleSubmit(submitSuccess, submitError)}
          id="peer-req-form"
        >
          <FormLayout className="justify-start">
            <Section componentsPerLine={1}>
              {/* [MCV-1258] Schema requires firstName/lastName/emailAddress but
                  the UI was missing the `*` indicators. Adding `required` here
                  surfaces the asterisks via FormLabel so users know upfront. */}
              <Row>
                <TextInput
                  name={'firstName'}
                  cyTag={TAGS.firstName}
                  label={'First Name'}
                  required
                />
              </Row>
              <Row>
                <TextInput name={'lastName'} cyTag={TAGS.lastName} label={'Last Name'} required />
              </Row>
              <Row>
                <TextInput
                  name={'emailAddress'}
                  cyTag={TAGS.emailAddress}
                  label={'Email Address'}
                  required
                />
              </Row>
              <Row>
                <MaskedInput
                  name={'phoneNum'}
                  label={'Phone Number'}
                  cyTag={TAGS.phoneNumber}
                  mask={'###-###-####'}
                  replacement={{ '#': /\d/ }}
                />
              </Row>
              <Row>
                <Select
                  name={'relationshipType'}
                  label={'Relationship'}
                  cyTag={TAGS.relationshipType}
                  options={PEER_RELATIONSHIP_OPTIONS}
                />
              </Row>
            </Section>
            <FormActions>
              <Button
                type="button"
                onClick={handleClose}
                cyTag={TAGS.closeBtn}
                colorVariant="secondary"
              >
                Cancel
              </Button>
              <Button cyTag={TAGS.submitBtn}>Send Request</Button>
            </FormActions>
          </FormLayout>
        </form>
      </FormProvider>
    </>
  );
};
